<template>

    <div id="product-configuration-view">

        <div id="view-configurators" v-if="blueprintMode === false">

            <AdminCanvasView :key="canvasView._id" v-for="canvasView in canvasViews" :bounding-box-state="boundingBox" :product-configuration-view="canvasView" v-show="canvasView.active"></AdminCanvasView>

        </div>

        <BoundingBoxConfigurator v-if="blueprintMode === false" :bounding-box="boundingBox" :view="viewInformations" @changeToBlueprintMode="changeToBlueprintMode"></BoundingBoxConfigurator>



        <div id="view-configurators" v-if="blueprintMode === true">

            <CanvasView :blueprint-configuration-mode="true" :productConfigurationView="blueprintProductConfigurationView"></CanvasView>

        </div>

        <AdminCanvasObjectsList v-if="blueprintMode === true" :current-active="blueprintProductConfigurationView" @save="productConfiguration.save()"></AdminCanvasObjectsList>

    </div>

</template>

<script>

    import CanvasView from "./../components/CanvasView";
    import BoundingBoxConfigurator from "./../components/BoundingBoxConfigurator";

    import AdminProductConfiguration from "./../structures/AdminProductConfiguration";
    import AdminCanvasView from "./../components/AdminCanvasView";

    import AppDebug from "./../AppDebug";
    import ProductConfigurationView from "./ProductConfigurationView";
    import ProductConfiguration from "../structures/ProductConfiguration";
    import CanvasObjectsList from "../components/CanvasObjectsList";
    import AdminCanvasObjectsList from "../components/AdminCanvasObjectsList";

    import BoundingBox from "../structures/canvas-objects/BoundingBox";

    import requestHelper from "../api/requestHelper";


    export default {
        name: "AdminProductConfigurationView",
        components: {
            BoundingBoxConfigurator,
            AdminCanvasView,
            CanvasView,
            AdminCanvasObjectsList
        },
        data: () => ({
            productId: 1,
            productConfiguration: null,
            blueprintProductConfigurationView: null,
            canvasObjectsOnProductConfigurationView: [],
            blueprintMode: false
        }),
        computed: {

          viewInformations() {

              const view = JSON.parse(window.view);

              return {
                  id: view.id,
                  title: view.title,
                  description: view.description,
                  printArea: view.printArea,
                  printType: view.printType
              };

          },

          boundingBox() {

              const productConfigurationViews = this.productConfiguration.getProductConfigurationViews();

              if (productConfigurationViews.length < 1)
                return null;

              const canvas = productConfigurationViews[0].canvas;

              return canvas.getCanvasObjects()[0];

          },

          activeCanvasView() {
              const activeView = this.canvasViews.find(canvasView => canvasView.active);
              if(activeView)
                  return activeView;
          },

          createableProductViews() {
              return this.productConfiguration.getCreateableProductViews();
          },

          canvasViews() {
              return this.productConfiguration.getProductConfigurationViews();
          },

        },
        methods: {

            async checkIfBlueprintExists(productId, viewId) {

                let productViews = await requestHelper.requestApiRoute('get', `/blueprint/${productId}`);

                for (let property in productViews) {

                    const productView = productViews[property];

                    console.log('view id: ', productView.viewId, viewId);

                    if (viewId === productView.viewId) {
                        return productView;
                    }

                }

                return null;

            },
            async changeToBlueprintMode() {

                let currentViewFromBlueprintCreate = JSON.parse(window.view);

                // if product id null the views don't load automatic by constructor and it is possible to control the process
                const productConfiguration = new ProductConfiguration(null);
                this.productConfiguration = productConfiguration;

                productConfiguration.setProductId(currentViewFromBlueprintCreate.productId);

                await productConfiguration.loadCreateableProductViews();

                this.blueprintProductConfigurationView = productConfiguration.createNewProductConfigurationView(
                    currentViewFromBlueprintCreate.id
                );

                console.log(currentViewFromBlueprintCreate);
                console.log(productConfiguration, this.blueprintProductConfigurationView);

                /**
                 * @type Canvas
                 */
                const canvas = this.blueprintProductConfigurationView.canvas;

                console.log('blueprint created canvas');

                /**
                 * @type BoundingBox
                 */
                const boundingBox = new BoundingBox(
                    canvas,
                    this.blueprintProductConfigurationView.boundingBox.x.min,
                    this.blueprintProductConfigurationView.boundingBox.x.max,
                    this.blueprintProductConfigurationView.boundingBox.y.min,
                    this.blueprintProductConfigurationView.boundingBox.y.max
                );

                boundingBox.set({
                    width: this.blueprintProductConfigurationView.boundingBox.sizes.width,
                    height: this.blueprintProductConfigurationView.boundingBox.sizes.height,
                    left: this.blueprintProductConfigurationView.boundingBox.x.current,
                    top: this.blueprintProductConfigurationView.boundingBox.y.current
                });

                console.log('blueprint created boundingBox');
                console.log({boundingBox});

                canvas.createCanvas(
                    `canvas-${this.blueprintProductConfigurationView.id}`,
                    this.blueprintProductConfigurationView.canvasWidth,
                    this.blueprintProductConfigurationView.canvasHeight,
                    boundingBox,
                    this.canvasObjectsOnProductConfigurationView
                );

                console.log('add boundingBox to canvas');

                if (! window.canvas )
                    window.canvas = [];

                window.canvas[`canvas-${this.blueprintProductConfigurationView.id}`] = canvas;

                this.blueprintMode = true;

                const blueprint = await this.checkIfBlueprintExists(productConfiguration.getProductId(), currentViewFromBlueprintCreate.id);

                if (blueprint) {
                    // console.log({blueprint});
                    canvas.createCanvasObjectsFromAPIResponse(blueprint.canvasObjects);

                }

                canvas.setCanAddElements(blueprint.canAddElements);
                canvas.setCanSortElements(blueprint.canSortElements);

            },

        },
        beforeMount() {

            this.productConfiguration = new AdminProductConfiguration();

        }
    }
</script>

<style lang="scss">



</style>